import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, MailIcon } from 'lucide-react';
export function ProjectManagement() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-1969">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200" data-id="element-1970">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-1971">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-1972">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-1973" />
            <span className="font-light" data-id="element-1974">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-1975">Maria Elina</h1>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-1976">
        <div className="max-w-7xl mx-auto text-center" data-id="element-1977">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1978">
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-4 flex flex-col items-center gap-2" data-id="element-1979">
              <img src="https://storage.yandexcloud.net/maria-images/images/Project management.svg" alt="Project Management" className="md:w-16 md:h-16 w-10 h-10" data-id="element-1980" />
              Project Management
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-1981">
              End-to-end project coordination ensuring timely delivery and
              seamless collaboration across teams
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="py-20 px-6 pt-[40px]" data-id="element-1982">
        <div className="max-w-7xl mx-auto" data-id="element-1983">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-1984">
            <div className="relative inline-block" data-id="element-1985">
              <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-1986">
                Service Packages
              </h3>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -bottom-2 left-0 right-0 h-[2px] bg-emerald-600" style={{
              clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)'
            }} data-id="element-1987" />
            </div>
          </motion.div>

          {/* Full Package - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8
        }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-8" style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
        }} data-id="element-1988">
            {/* Holographic gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/15 via-teal-400/15 to-cyan-400/15" data-id="element-1989" />
            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1990" />

            {/* Featured badge */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6" data-id="element-1991">
              <span className="inline-block px-2.5 py-1 text-xs md:px-4 md:py-1.5 md:text-sm font-light text-emerald-700 bg-emerald-100 rounded-full border border-emerald-200" data-id="element-1992">
                Complete Solution
              </span>
            </div>

            <div className="relative z-10 p-10" data-id="element-1993">
              <h4 className="text-3xl font-light text-stone-900 mb-8 tracking-tight" data-id="element-1994">
                Full Package
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-1995">
                {/* Column 1 */}
                <div data-id="element-1996">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-1997">
                    Project Coordination
                  </h5>
                  <ul className="space-y-3" data-id="element-1998">
                    <li className="flex items-start gap-3" data-id="element-1999">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2000" />
                      <span className="text-stone-700 font-light" data-id="element-2001">
                        Timeline & milestone management
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2002">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2003" />
                      <span className="text-stone-700 font-light" data-id="element-2004">
                        Stakeholder communication
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2005">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2006" />
                      <span className="text-stone-700 font-light" data-id="element-2007">
                        Resource allocation
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2008">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2009" />
                      <span className="text-stone-700 font-light" data-id="element-2010">
                        Risk monitoring & mitigation
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Column 2 */}
                <div data-id="element-2011">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-2012">
                    Delivery & Reporting
                  </h5>
                  <ul className="space-y-3" data-id="element-2013">
                    <li className="flex items-start gap-3" data-id="element-2014">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2015" />
                      <span className="text-stone-700 font-light" data-id="element-2016">
                        Progress reporting & dashboards
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2017">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2018" />
                      <span className="text-stone-700 font-light" data-id="element-2019">
                        Presentations & milestone delivery
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2020">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2021" />
                      <span className="text-stone-700 font-light" data-id="element-2022">
                        Budget tracking
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-2023">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2024" />
                      <span className="text-stone-700 font-light" data-id="element-2025">
                        Handover documentation
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Enquire Button */}
              <div className="mt-10" data-id="element-2026">
                <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Full%20Package%20%E2%80%93%20Project%20Management&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Full%20Package%20for%20Project%20Management%2C%20which%20includes%3A%0D%0A%0D%0AProject%20Coordination%3A%0D%0A%E2%80%A2%20Timeline%20%26%20milestone%20management%0D%0A%E2%80%A2%20Stakeholder%20communication%0D%0A%E2%80%A2%20Resource%20allocation%0D%0A%E2%80%A2%20Risk%20monitoring%20%26%20mitigation%0D%0A%0D%0ADelivery%20%26%20Reporting%3A%0D%0A%E2%80%A2%20Progress%20reporting%20%26%20dashboards%0D%0A%E2%80%A2%20Quality%20assurance%20checkpoints%0D%0A%E2%80%A2%20Budget%20tracking%0D%0A%E2%80%A2%20Handover%20documentation%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                y: -3
              }} className="group/btn inline-block relative" data-id="element-2027">
                  <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                  clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                }} data-id="element-2028" />
                  <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
                  clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                }} data-id="element-2029">
                    <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2030" />
                    <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-2031">
                      <MailIcon className="w-4 h-4" data-id="element-2032" />
                      Enquire
                    </span>
                  </div>
                </motion.a>
              </div>
            </div>

            {/* Angular corner accents */}
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2033" />
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2034" />
          </motion.div>

          {/* Other Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2035">
            {/* Coordination Package */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2036">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2037" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2038" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2039">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2040">
                  Coordination Package
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2041">
                  <li className="flex items-start gap-3" data-id="element-2042">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2043" />
                    <span className="text-stone-700 font-light" data-id="element-2044">
                      Timeline management
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2045">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2046" />
                    <span className="text-stone-700 font-light" data-id="element-2047">
                      Team coordination
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2048">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2049" />
                    <span className="text-stone-700 font-light" data-id="element-2050">
                      Progress tracking
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2051">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2052" />
                    <span className="text-stone-700 font-light" data-id="element-2053">
                      Milestone reporting
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2054">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2055" />
                    <span className="text-stone-700 font-light" data-id="element-2056">
                      Stakeholder updates
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2057">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Coordination%20Package&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Coordination%20Package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Timeline%20management%0D%0A%E2%80%A2%20Team%20coordination%0D%0A%E2%80%A2%20Progress%20tracking%0D%0A%E2%80%A2%20Milestone%20reporting%0D%0A%E2%80%A2%20Stakeholder%20updates%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2058">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2059" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2060">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2061" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2062">
                        <MailIcon className="w-4 h-4" data-id="element-2063" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2064" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2065" />
            </motion.div>

            {/* Consultation */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2066">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2067" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2068" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2069">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2070">
                  Consultation
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2071">
                  <li className="flex items-start gap-3" data-id="element-2072">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2073" />
                    <span className="text-stone-700 font-light" data-id="element-2074">
                      Project audit
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2075">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2076" />
                    <span className="text-stone-700 font-light" data-id="element-2077">
                      Process optimization recommendations
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2078">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2079" />
                    <span className="text-stone-700 font-light" data-id="element-2080">
                      Risk assessment
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2081">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2082" />
                    <span className="text-stone-700 font-light" data-id="element-2083">
                      Strategic planning support
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2084">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Consultation%20(Project%20Management)&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Consultation%20package%20for%20Project%20Management%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Project%20audit%0D%0A%E2%80%A2%20Process%20optimization%20recommendations%0D%0A%E2%80%A2%20Risk%20assessment%0D%0A%E2%80%A2%20Strategic%20planning%20support%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2085">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2086" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2087">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2088" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2089">
                        <MailIcon className="w-4 h-4" data-id="element-2090" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2091" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2092" />
            </motion.div>

            {/* On-Demand Support */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-2093">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-2094" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-2095" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-2096">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-2097">
                  On-Demand Support
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-2098">
                  <li className="flex items-start gap-3" data-id="element-2099">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2100" />
                    <span className="text-stone-700 font-light" data-id="element-2101">
                      Ad-hoc check-ins
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2102">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2103" />
                    <span className="text-stone-700 font-light" data-id="element-2104">
                      Troubleshooting & problem-solving
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2105">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-2106" />
                    <span className="text-stone-700 font-light" data-id="element-2107">
                      Team alignment sessions
                    </span>
                  </li>
                </ul>
                <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-2108">
                  *Flexible hourly arrangements
                </p>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-2109">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20On-Demand%20Support%20(Project%20Management)&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20On-Demand%20Support%20package%20for%20Project%20Management%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Ad-hoc%20project%20check-ins%0D%0A%E2%80%A2%20Troubleshooting%20%26%20problem-solving%0D%0A%E2%80%A2%20Team%20alignment%20sessions%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-2110">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-2111" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-2112">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-2113" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-2114">
                        <MailIcon className="w-4 h-4" data-id="element-2115" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2116" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-2117" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-2118">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2119">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-2120">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-2121">
              Have a specific request?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-2122">
              Let's discuss what we can create together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-2123">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-2124" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-2125">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-2126" />
                <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-2127">
                  <MailIcon className="w-4 h-4" data-id="element-2128" />
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}